/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface WelcomeBackOffer
 */
export interface WelcomeBackOffer {
    /**
     *
     * @type {string}
     * @memberof WelcomeBackOffer
     */
    id: string;
    /**
     * Exclusive UTC booking deadline as an ISO 8601 string.
     * @type {string}
     * @memberof WelcomeBackOffer
     */
    expiresAt: string;
    /**
     *
     * @type {number}
     * @memberof WelcomeBackOffer
     */
    amount: number;
    /**
     *
     * @type {number}
     * @memberof WelcomeBackOffer
     */
    minimumRoomCost: number;
}

/**
 * Check if a given object implements the WelcomeBackOffer interface.
 */
export function instanceOfWelcomeBackOffer(value: object): value is WelcomeBackOffer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('minimumRoomCost' in value) || value['minimumRoomCost'] === undefined) return false;
    return true;
}

export function WelcomeBackOfferFromJSON(json: any): WelcomeBackOffer {
    return WelcomeBackOfferFromJSONTyped(json, false);
}

export function WelcomeBackOfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): WelcomeBackOffer {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'expiresAt': json['expires_at'],
        'amount': json['amount'],
        'minimumRoomCost': json['minimum_room_cost'],
    };
}

export function WelcomeBackOfferToJSON(json: any): WelcomeBackOffer {
    return WelcomeBackOfferToJSONTyped(json, false);
}

export function WelcomeBackOfferToJSONTyped(value?: WelcomeBackOffer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'id': value['id'],
        'expires_at': value['expiresAt'],
        'amount': value['amount'],
        'minimum_room_cost': value['minimumRoomCost'],
    };
}

